import {
  companyId,
  passportId,
  openId,
  cityId,
  areaId,
  deviceToken
} from '@/defines/user'
import {
  deviceId,
  appVersion,
  browserEnv,
  appInfo,
  thirdSource,
  appKey
} from '@/defines/environment'
import {
  isMallAndroid,
  isMallIOS,
  isMCMallKeyCustomerIOS,
  isMCMallKeyCustomerAndroid
} from '@mc/mc-base-env/src/web/platform'
import { getGeoLocation, getGeoLocationCached } from '../geo_location'

import { userInfo } from '@/utils/user'
const appSystem = (() => {
  if (isMallAndroid()) return 'android'
  if (isMallIOS()) return 'ios'
  switch (browserEnv) {
    case 'weixin':
      return 'wx'
    case 'baidu':
      return 'baidump'
    case 'toutiao':
      return 'toutiaomp'
    case 'douyin':
      return 'douyinmp'
    case 'AppGallery Connect':
      return 'harmony'
    default:
      return 'web'
  }
})()

const os = (() => {
  // 先判断 app
  if (isMallAndroid()) {
    return 'Android'
  }
  if (isMallIOS()) {
    return 'iOS'
  }
  // 再根据 ua 判断浏览器或者 webview
  const ua = window.navigator.userAgent
  switch (true) {
    case ua.indexOf('Windows') > -1:
      // windows 里一般肯定有 Windows
      return 'Windows'
    case ua.indexOf('Macintosh') > -1:
      // iOS 里有 Like Mac OS X，所以检测 Macintosh
      return 'macOS'
    case ua.indexOf('Android') > -1:
      return 'Android'
    case ua.indexOf('iPhone') > -1 || ua.indexOf('iPad') > -1:
      return 'iOS'
    case ua.indexOf('Linux') > -1:
      // Android 里常常也有 Linux 字样，这个一定要放在 Android 后面
      return 'Linux'
    case ua.indexOf('Harmony') > -1:
      // Android 里常常也有 Linux 字样，这个一定要放在 Android 后面
      return 'Harmony'
    default:
      return 'unknown'
  }
})()

getGeoLocation()

const geolocation = getGeoLocationCached()

const isMCMallKeyCustomerApp =
  isMCMallKeyCustomerIOS() || isMCMallKeyCustomerAndroid()

export const baseParams = {
  uid: companyId,
  passport_id: passportId,
  open_id: openId,
  device_id: deviceId,
  sn: '',
  app_version: appVersion || 'noversion',
  app_system: appSystem,
  app_runtime: 'h5',
  net: appInfo.net || '',
  mno: '',
  os,
  os_version: appInfo.os_version || '',
  city_id: cityId,
  area_id: areaId,
  latitude: geolocation.lat,
  longitude: geolocation.lng,
  app_id: isMCMallKeyCustomerApp ? 20 : 1,
  tid: deviceToken || '',
  commonParams: {
    third_source: thirdSource.thirdSource,
    third_source_content: thirdSource.thirdSourceContent,
    project_name: 'mall-marketing',
    mall_type: String(userInfo.mallType),
    app_key: appKey
  }
}
